import constants from './componentManifestResolver.constants';
import type {
  FetchManifest,
  ResolveManifest,
  SyncedFetchManifest,
  SyncedResolveManifest
} from './componentManifestResolver.types';
import ComponentManifestResolver from './resolvers/ComponentManifest/ComponentManifest.resolver';
import ComponentManifestSyncedResolver from './resolvers/ComponentManifest/ComponentManifest.synced.resolver';

function createComponentManifestResolver(fetchManifest: FetchManifest): ResolveManifest {
  if (!fetchManifest) {
    throw new Error(constants.notFetcherError);
  }

  const resolveManifest: ResolveManifest = (manifest, options) => {
    const componentManifestResolver = new ComponentManifestResolver({
      fetchManifest,
      manifest,
      resolveElements: options?.resolveElements
    });
    const resolvedManifest = componentManifestResolver.resolve();

    return resolvedManifest;
  };

  return resolveManifest;
}

function createComponentManifestSyncedResolver(
  fetchManifest: SyncedFetchManifest
): SyncedResolveManifest {
  if (!fetchManifest) {
    throw new Error(constants.notFetcherError);
  }

  const syncedResolveManifest: SyncedResolveManifest = (manifest) => {
    const componentManifestResolver = new ComponentManifestSyncedResolver({
      fetchManifest,
      manifest
    });
    const resolvedManifest = componentManifestResolver.resolve();

    return resolvedManifest;
  };

  return syncedResolveManifest;
}

export { createComponentManifestResolver, createComponentManifestSyncedResolver };
